import { generateCategoricalChart as a } from "./generateCategoricalChart.js";
import { Bar as i } from "../cartesian/Bar.js";
import { XAxis as r } from "../cartesian/XAxis.js";
import { YAxis as o } from "../cartesian/YAxis.js";
import { formatAxisMap as t } from "../util/CartesianUtils.js";
var f = a({
  chartName: "BarChart",
  GraphicalChild: i,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: r
  }, {
    axisType: "yAxis",
    AxisComp: o
  }],
  formatAxisMap: t
});
export {
  f as BarChart
};
